import React from "react";
import { Button } from "@mui/material";
import { useMutation } from "react-query";
import { useDataProvider } from "react-admin";

const RecreateMP3Button = ({ messageId }) => {
  const dataProvider = useDataProvider();

  const { mutate, isLoading } = useMutation(["recreateMp3", messageId], () =>
    dataProvider.reprocess({ id: messageId })
  );

  return (
    <Button onClick={() => mutate()} disabled={isLoading}>
      Reprocess
    </Button>
  );
};

export default RecreateMP3Button;
